module.exports = __webpack_public_path__ + "static/productionS-mobile-36f5d63aa64c8aedce1da4d724a92dcf.svg";